module.exports = __webpack_public_path__ + "static/media/Dutch.e57cc8af.jpg";